export default {"src":"https://fishbrain.com/_next/static/media/circle_black.e00a678a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};